import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M24.0109 7.23135C24.0109 7.23135 23.8109 5.53135 23.0109 4.83135C22.1109 3.83135 21.1109 3.83135 20.6109 3.83135C17.2109 3.63135 12.2109 3.63135 12.2109 3.63135C12.2109 3.63135 7.21094 3.63135 3.81094 3.83135C3.31094 3.93135 2.31094 3.93135 1.41094 4.83135C0.710938 5.53135 0.410938 7.23135 0.410938 7.23135C0.410938 7.23135 0.210938 9.13135 0.210938 11.1313V12.9313C0.210938 14.8313 0.410938 16.8313 0.410938 16.8313C0.410938 16.8313 0.610938 18.5313 1.41094 19.2313C2.31094 20.2313 3.51094 20.1313 4.01094 20.2313C5.91094 20.4313 12.2109 20.4313 12.2109 20.4313C12.2109 20.4313 17.2109 20.4313 20.6109 20.1313C21.1109 20.0313 22.1109 20.0313 23.0109 19.1313C23.7109 18.4313 24.0109 16.7313 24.0109 16.7313C24.0109 16.7313 24.2109 14.8313 24.2109 12.8313V11.0313C24.2109 9.13135 24.0109 7.23135 24.0109 7.23135ZM9.71094 15.1313V8.43135L16.2109 11.8313L9.71094 15.1313Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }